export default "/images/vendor/flag-icon-css/flags/4x3/qa.svg?a4f5c16c0a4ab4c14fdf64fb6c6acafe";